import React from "react";
import { Chip, Stack, TableCell, TableHead, TableRow, styled, Typography, Avatar } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';

const LegitChip = styled(Chip)(
    ({ theme }) => `
        background: white;
        border-radius: 2px !important;
        color: black;
        font-weight: normal;
        border: 1px solid black;
        font-family: inherit;
        font-size: ${theme.typography.caption.fontSize};
    `
)

const CustomTableCell = styled(TableCell)(
    ({ theme }) => `
        & .MuiTypography-root {
            text-align: center !important;
        }
    `
)

const CustomCodeLabel = styled(Avatar)(
    ({ theme }) => `
        background: ${theme.palette.teritiary.main};
        color: white;
        width: 36px;
        height: 36px;
        font-size: 14px;
        margin-left: 1rem !important;
    `
)


export default function StateItem({ data, index }) {

    return (
        <TableRow sx={{background: index % 2 == 0 ? "#F4F4F0" : "#FFFFFF"}}>
            <TableCell>
                <Stack direction="row" spacing={2} alignItems="center">
                    <CustomCodeLabel>{data.nominationCode}</CustomCodeLabel>
                    <Typography variant="body1" color="initial">{data?.nomination}</Typography>
                </Stack>
            </TableCell>
            <CustomTableCell>
                <Stack alignItems="center">
                    {data.visa_subclass190 == "1" && <CheckCircleIcon color="success" />}
                    {data.visa_subclass190 == "0" && <CancelIcon color="error" />}
                    {data.visa_subclass190 == "2" &&  <CheckIcon style={{ color: 'blue' }} />}
                </Stack>
            </CustomTableCell>
            <CustomTableCell>
                <Stack alignItems="center">
                    {data.visa_subclass491 == "1" && <CheckCircleIcon color="success" />}
                    {data.visa_subclass491 == "0" && <CancelIcon color="error" />}
                    {data.visa_subclass491 == "2" &&  <CheckIcon style={{ color: 'blue' }} />}
                </Stack>
            </CustomTableCell>
        </TableRow>
    );
}

